<template>
    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2">
                        <h2 class="blueFont ">مراجعة الطلبات</h2>
                    </div>
                </div>

                <div class="row my-3">
                    <div class="table-responsive">
                        <table class="table  table-hover table-borderless">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col">نوع الوثيقه</th>
                                    <th scope="col">اسم المستفيد من الخدمه</th>
                                    <th scope="col">درجه القرابه</th>
                                    <th scope="col">الرقم القومي</th>
                                    <th scope="col">السعر</th>
                                    <th scope="col">عدد النسخ</th>
                                    <th scope="col">السعر الاجمالى</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="doc in Docs" :key="doc.Id">
                                    <td><input type="text" readonly="readonly" class="form-control text-center"
                                            placeholder="" aria-label="" :value="DocType"></td>
                                    <td> <input type="text" readonly="readonly" class="form-control text-center"
                                            placeholder="" aria-label="" :value="doc.name.fullName"></td>
                                    <td> <input type="text" readonly="readonly" class="form-control text-center"
                                            placeholder="" aria-label="" :value="relations[doc.relationCode]"></td>
                                    <td> <input type="text" readonly="readonly" class="form-control text-center"
                                            placeholder="" aria-label="" :value="doc.nid.nationalIdenNumber"></td>
                                    <td> <input type="text" readonly="readonly" class="form-control text-center"
                                            placeholder="" aria-label="" :value="serviceprice"></td>
                                    <td> <input type="text" readonly="readonly" class="form-control text-center"
                                            placeholder="" aria-label=""
                                            :value="getCopiesCount(doc.numberOfCopies)"></td>
                                    <td> <input type="text" readonly="readonly" class="form-control text-center"
                                            placeholder="" aria-label=""
                                            :value="serviceprice * getCopiesCount(doc.numberOfCopies)">
                                    </td>
                                </tr>


                            </tbody>
                            <tfoot>
                                <tr class="table-dark tabel_footer">
                                    <td colspan="6">الاجمالى</td>
                                    <td class="text-center">{{ TotalPrice }}</td>
                                </tr>
                                <tr>
                                    <td colspan="7" class="hint blueFont">يضاف إلي رسوم الخدمة ، تكلفة التوصيل بالبريد
                                        المصري 12 ج.م عن كل خمسة وثائق بالإضافة إلي عمولة التحصيل الإلكتروني حسب وسيلة
                                        الدفع الإلكتروني المستخدمة.</td>
                                </tr>
                            </tfoot>

                        </table>
                    </div>
                </div>

                <div class="col-12 mb-2">
                    <h2 class="blueFont ">بيانات توصيل الطلب</h2>
                </div>

                <div class="row mb-3">
                    <div class="col-md-2">
                        <label for="" class="form-label">رقم الشقة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.departmentNo" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.departmentNo.$touch()">

                                <p class="data--required" v-for="error of v$.form.departmentNo.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>


                        </div>
                    </div>

                    <div class="col-md-2">
                        <label for="" class="form-label">رقم الدور</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.floorNo" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.floorNo.$touch()">

                                <p class="data--required" v-for="error of v$.form.floorNo.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>


                        </div>
                    </div>

                    <div class="col-md-2">
                        <label for="" class="form-label">رقم المنزل</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.flatNo" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.flatNo.$touch()">

                                <p class="data--required" v-for="error of v$.form.flatNo.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <label for="" class="form-label">الشارع</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.streetName" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.streetName.$touch()">

                                <p class="data--required" v-for="error of v$.form.streetName.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>


                        </div>
                    </div>

                    <div class="col-md-4">
                        <label for="" class="form-label">المدينة/اسم الحى</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.districtName" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.districtName.$touch()">

                                <p class="data--required" v-for="error of v$.form.districtName.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="" class="form-label">العنوان التفصيلى شاملا علامة مميزه</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.detailedAddress" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.detailedAddress.$touch()">

                                <p class="data--required" v-for="error of v$.form.detailedAddress.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>


                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label for="" class="form-label"> المحافظة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="govCode" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.govCode.$touch()">
                                    <option v-for="gov in GovCode_lookups" :key="gov.Id" :value="gov.Code">{{ gov.Name
                                    }}
                                    </option>
                                </select>
                                <p class="data--required" v-for="error of v$.govCode.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-4">
                        <label for="" class="form-label">مكتب البريد</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="form.postalCode" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.form.postalCode.$touch()">
                                    <option v-for="postal in FilteredPostalLookups" :key="postal.Id"
                                        :value="postal.Code">
                                        {{ postal.Name }}
                                    </option>
                                </select>
                                <p class="data--required" v-for="error of v$.form.postalCode.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-4">
                        <label for="" class="form-label"> قسم الشرطة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="form.policeCode" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.form.policeCode.$touch()">
                                    <option v-for="dept in policeCode_lookups" :key="dept.Id" :value="dept.Code">
                                        {{ dept.Name }}
                                    </option>
                                </select>
                                <p class="data--required" v-for="error of v$.form.policeCode.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="" class="form-label">رقم الموبايل 1</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.mobile1" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.mobile1.$touch()">

                                <p class="data--required" v-for="error of v$.form.mobile1.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label for="" class="form-label">رقم الموبايل 2</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.mobile2" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.mobile2.$touch()">

                                <p class="data--required" v-for="error of v$.form.mobile2.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="row my-5 justify-content-center">
                        <div :hidden="isNid === true" class="col-12 col-sm-4 mx-5 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="close()" type="button" class="btn btn-light mx-3 align-self-center">
                                    تعديل الطلب
                                </button>
                            </div>
                        </div>

                        <div class="col-12 col-sm-4 mx-5 mb-3">
                            <div class="d-flex justify-content-center">
                                <button id="btn" @click="send_request" type="button"
                                    class="btn btn-light mx-3 align-self-center">
                                    تسجيل الطلب
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import useVuelidate from "@vuelidate/core";
import { mapGetters, mapActions } from "vuex";
import validations from "@/shared/validations";
import sharedMethods from "@/shared/sharedMethods";
import sharedData from "@/shared/sharedData";
import { debugError, debugLog } from "@/plugins/debug";
export default {
    ...sharedMethods,
    name: 'ReviewComp',
    created() {
        sharedMethods.get_govCodes().then(res => { this.GovCode_lookups = res.sort(sharedMethods.compare); });
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
    watch: {
        // whenever govCode changes, this function will run
        govCode(newValue) {
            if (newValue) {
                sharedMethods.get_postalCodes(this.govCode).then(res => { this.postalCode_lookups = res.sort(sharedMethods.compare); });
                sharedMethods.get_policeCodes(this.govCode).then(res => { this.policeCode_lookups = res.sort(sharedMethods.compare); });
            }
        }
    },
    props: {
        serviceprice: Number,
        DocCode: String,
        DocData: Object,
        NidDocData: Object,
        DocType: String,
        isNid: Boolean
    },
    setup(props, { emit }) {
        const close = () => {
            emit('close')
        }
        return { close }
    },
    data() {
        return {
            v$: useVuelidate(),
            GovCode_lookups: [], // governorate code
            postalCode_lookups: [], // postal code code
            policeCode_lookups: [], // police department code
            relations: sharedData.relations,
            DocName: '',
            govCode: '',
            form: {
                postalCode: '',
                policeCode: '',

                departmentNo: '',
                floorNo: '',
                flatNo: '',

                streetName: '',
                districtName: '',

                detailedAddress: '',

                // address: '',
                email: '',
                mobile1: '',
                mobile2: '',
            },
        }
    },
    validations() {
        return {
            ...validations.Review
        }
    },
    computed: {
        ...mapGetters({ Docs: "StateDocs", options: "StateOptions" }),

        TotalPrice() {
            return Object.values(this.Docs).reduce((total, doc) => {
                return total + (this.getCopiesCount(doc.numberOfCopies) * this.serviceprice);
            }, 0);
        },
        FilteredPostalLookups() {
            return this.postalCode_lookups.filter(e => {
                return e.Code !== "0";
            })
        },
    },

    methods: {
        ...mapActions(["resetDocs", "saveDeliveryUser", "toggleRegulations"]),

        getCopiesCount(numberOfCopies) {
            const parsedCopies = Number.parseInt(String(numberOfCopies), 10);
            return Number.isNaN(parsedCopies) ? 0 : parsedCopies;
        },


        async send_request() {
            this.v$.$validate();
            debugLog('Button disabled:', document.getElementById('btn').disabled);
            if (!document.getElementById('btn').disabled) {
                document.getElementById('btn').disabled = true;
                if (!this.v$.$error) {
                    // if (this.form.mobile1 !== this.form.mobile2) {
                    if (this.isNid) {
                        let EditedNidDocData = this.NidDocData;
                        EditedNidDocData.contactDetails.mobile1 = this.form.mobile1;
                        EditedNidDocData.contactDetails.mobile2 = this.form.mobile2;
                        debugLog('DocData_CsoRequest:', EditedNidDocData);
                        await this.$api.requests.createCsoDoc(EditedNidDocData, this.options)
                            .then(res => {
                                debugLog('====Send request Response========', res);
                                this.saveDeliveryUser(this.form); // save requester data to store

                                debugLog('SHIPMENT DATA:', {
                                        "requestID": (res.data.Id).toString(),
                                        "customerAddress": {
                                            "address": `رقم الشقة: ${this.form.departmentNo} رقم الدور: ${this.form.floorNo} رقم العقار: ${this.form.flatNo} الشارع: ${this.form.streetName} الحى/المدينة: ${this.form.districtName} العنوان التفصيلى: ${this.form.detailedAddress}`,
                                            "governorateCode": Number(this.govCode),
                                            "policeDeptCode": Number(this.form.policeCode),
                                            "postOfficeCode": Number(this.form.postalCode),
                                        }
                                    });
                                const shipmentData = {
                                    "requestID": (res.data.Id).toString(),
                                    "customerAddress": {
                                        "address": `رقم الشقة: ${this.form.departmentNo} رقم الدور: ${this.form.floorNo} رقم العقار: ${this.form.flatNo} الشارع: ${this.form.streetName} الحى/المدينة: ${this.form.districtName} العنوان التفصيلى: ${this.form.detailedAddress}`,
                                        "governorateCode": Number(this.govCode),
                                        "policeDeptCode": Number(this.form.policeCode),
                                        "postOfficeCode": Number(this.form.postalCode),
                                    }
                                }
                                this.$api.requests.shipmentInfo(shipmentData)
                                    .then(res => {
                                        debugLog('====Shipment request Response========', res);
                                    }).catch(err => {
                                        debugError(`${err}`);
                                    });
                                this.$router.push({ name: 'requestSent', params: { req_id: (res.data.Id).toString() } })
                                this.resetDocs(); // reset all birth docs from store  
                            }).catch(err => {
                                debugError(`${err}`); 
                            });
                    } else {

                        let EditedDocData = this.DocData;
                        EditedDocData.contactDetails.mobile1 = this.form.mobile1;
                        EditedDocData.contactDetails.mobile2 = this.form.mobile2;
                        debugLog('DocData_CsoRequest:', EditedDocData);
                        await this.$api.requests.createCsoDoc(EditedDocData, this.options)
                            .then(res => {
                                debugLog('====Send request Response========', res); 
                                this.saveDeliveryUser(this.form); // save requester data to store

                                debugLog('SHIPMENT DATA:', {
                                        "requestID": (res.data.Id).toString(),
                                        "customerAddress": {
                                            "address": `رقم الشقة: ${this.form.departmentNo} رقم الدور: ${this.form.floorNo} رقم العقار: ${this.form.flatNo} الشارع: ${this.form.streetName} الحى/المدينة: ${this.form.districtName} العنوان التفصيلى: ${this.form.detailedAddress}`,
                                            "governorateCode": Number(this.govCode),
                                            "policeDeptCode": Number(this.form.policeCode),
                                            "postOfficeCode": Number(this.form.postalCode),
                                        }
                                    });

                                const shipmentData = {
                                    "requestID": (res.data.Id).toString(),
                                    "customerAddress": {
                                        // "address": ` العنوان التفصيلى: ${this.form.detailedAddress} الحى/المدينة: ${this.form.districtName} الشارع: ${this.form.streetName}  رقم العقار: ${this.form.flatNo} رقم الدور: ${this.form.floorNo} رقم الشقة: ${this.form.departmentNo}` ,
                                        "address": `رقم الشقة: ${this.form.departmentNo} رقم الدور: ${this.form.floorNo} رقم العقار: ${this.form.flatNo} الشارع: ${this.form.streetName} الحى/المدينة: ${this.form.districtName} العنوان التفصيلى: ${this.form.detailedAddress}`,
                                        "governorateCode": Number(this.govCode),
                                        "policeDeptCode": Number(this.form.policeCode),
                                        "postOfficeCode": Number(this.form.postalCode),
                                    }
                                }

                                this.$api.requests.shipmentInfo(shipmentData)
                                    .then(res => {
                                        debugLog('====Shipment request Response========', res); 
                                    }).catch(err => {
                                        debugError(`${err}`); 
                                    });
                                this.$router.push({ name: 'requestSent', params: { req_id: (res.data.Id).toString() } })
                                this.resetDocs(); // reset all birth docs from store  
                            }).catch(err => {
                                debugError(`${err}`); 
                            });
                    }
                    // } else {
                    //     this.$alerts.toast.error('يجب أن يكون موبايل1 مختلفا عن موبايل2');
                    // }

                } else {
                    this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
                }
            }
        },


        //auto fill for testing
        AutoFill() {
            this.form.address = "أكتوبر/الحى الأول";
            this.form.mobile1 = "01092910607";
            this.form.mobile2 = "01092910607";

        },
    }
}
</script>
